import React from 'react'
import { coinMeta } from '../../../features/quick-sell/coinMeta'
import { useAllDepositsQuery } from '../../../features/quick-sell/quickSellSlice'
import { stringReduce } from '../../../utils/stringReduce'

const History = () => {
    const { data, isLoading } = useAllDepositsQuery();

    console.log({ data })
    return (
        <div><div className='bg-black flex flex-col gap-4 px-4 lg:px-10 py-10 mt-6' >
            <div className='relative flex justify-between'>
                <h3 className='text-indigo-500 text-xl font-medium'>
                    Deposit History
                </h3>
            </div>

            <div className='overflow-x-auto relative'>
                <table className='w-full text-sm text-left text-gray-400'>
                    <thead className='text-xs uppercase bg-gray-700 text-gray-300'>
                        <tr>
                            <th scope='col' className='py-3 px-6'>
                                Deposit ID
                            </th>
                            <th scope='col' className='py-3 px-6'>
                                Coin
                            </th>

                            <th scope='col' className='py-3 px-6'>
                                Crypto Amount
                            </th>
                            <th scope='col' className='py-3 px-6'>
                                Amount (NGN)
                            </th>
                            <th scope='col' className='py-3 px-6'>
                                Amount (USD)
                            </th>
                            <th scope='col' className='py-3 px-6 w-200'>
                                Status
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.map((data: any, index: number) => {


                            return (
                                <tr
                                    className='border-b bg-transparent border-gray-700'
                                    key={index}
                                >
                                    <th
                                        scope='row'
                                        className='py-4 px-6 font-medium whitespace-nowrap text-white'
                                    >
                                        {data._id}
                                    </th>
                                    <td className='py-4 px-6'>{coinMeta(data?.coin).label}</td>


                                    <td className='py-4 px-6'>{Number(data.amount || 0)} {coinMeta(data?.coin).symbol}</td>
                                    <td className='py-4 px-6'>{Number(data.amountInNGN).toFixed(2)}</td>
                                    <td className='py-4 px-6'>{Number(data.amountInUsd).toFixed(2)}</td>
                                    <td className='py-4 px-6 w-40'>
                                        <div className='badge-info px-4 py-2 rounded-full uppercase'>
                                            {data.status}
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div></div>
    )
}

export default History